import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmationDialogComponent } from './confirmation.component';
import { ErrorDialogComponent } from './error.component';
import { SuccessDialogComponent } from './success.component';

@NgModule({
  imports: [CommonModule, MatCardModule, TranslateModule, MatButtonModule, MatDialogModule, MatSlideToggleModule],
  declarations: [ConfirmationDialogComponent, ErrorDialogComponent, SuccessDialogComponent],
  exports: [ConfirmationDialogComponent, ErrorDialogComponent, SuccessDialogComponent],
})
export class AppDialogModule {}
